import { render, staticRenderFns } from "./storyboard2.vue?vue&type=template&id=aa6bb0b2"
import script from "./storyboard2.vue?vue&type=script&lang=js"
export * from "./storyboard2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports